import type { ReactNode } from "react";
import styles from "./EmptyState.module.css";

export interface EmptyStateProps {
  /** Illustration-plads: ikon/emoji/SVG. Default er en neutral markering. */
  illustration?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  /** Call-to-action, typisk en <Button>. */
  cta?: ReactNode;
}

export function EmptyState({
  illustration = "∅",
  title,
  description,
  cta,
}: EmptyStateProps) {
  return (
    <div className={styles.empty}>
      <div className={styles.art} aria-hidden="true">
        {illustration}
      </div>
      <p className={styles.title}>{title}</p>
      {description !== undefined && (
        <p className={styles.description}>{description}</p>
      )}
      {cta !== undefined && <div className={styles.cta}>{cta}</div>}
    </div>
  );
}
